import type { ReactElement } from 'react';
import { ApiError } from '@pillar-portal/api-types';
import { Alert, AlertDescription } from '@/components/ui/alert';

export interface InfiniteScrollListStateCopy {
    loadingLabel: string;
    emptyLabel: string;
    endOfListLabel: string;
    genericErrorLabel: string;
}

export const DefaultInfiniteScrollListStateCopy: InfiniteScrollListStateCopy = {
    loadingLabel: 'Loading...',
    emptyLabel: 'No items found.',
    endOfListLabel: 'End of list.',
    genericErrorLabel: 'Failed to load items.',
};

export function resolveInfiniteScrollListErrorMessage(
    error: unknown,
    stateCopy: InfiniteScrollListStateCopy = DefaultInfiniteScrollListStateCopy
): string {
    if (error instanceof ApiError && error.status === 403) {
        return 'Access denied.';
    }
    if (error instanceof Error) {
        return error.message;
    }
    return stateCopy.genericErrorLabel;
}

interface InfiniteScrollListLabelProps {
    readonly label?: string;
}

export function InfiniteScrollListLoadingState({
    label = DefaultInfiniteScrollListStateCopy.loadingLabel,
}: InfiniteScrollListLabelProps): ReactElement {
    return <div>{label}</div>;
}

export function InfiniteScrollListEmptyState({
    label = DefaultInfiniteScrollListStateCopy.emptyLabel,
}: InfiniteScrollListLabelProps): ReactElement {
    return <div className="text-sm text-gray-600">{label}</div>;
}

export function InfiniteScrollListEndOfListState({
    label = DefaultInfiniteScrollListStateCopy.endOfListLabel,
}: InfiniteScrollListLabelProps): ReactElement {
    return <div className="mt-3 text-xs text-gray-600">{label}</div>;
}

interface InfiniteScrollListErrorStateProps {
    readonly error: unknown;
    readonly genericErrorLabel?: string;
}

export function InfiniteScrollListErrorState({
    error,
    genericErrorLabel = DefaultInfiniteScrollListStateCopy.genericErrorLabel,
}: InfiniteScrollListErrorStateProps): ReactElement {
    return (
        <Alert variant="destructive">
            <AlertDescription>
                {resolveInfiniteScrollListErrorMessage(error, {
                    ...DefaultInfiniteScrollListStateCopy,
                    genericErrorLabel,
                })}
            </AlertDescription>
        </Alert>
    );
}
